import { CommonModule } from '@angular/common'
import { Component, Input, ChangeDetectionStrategy, EventEmitter, Output, ChangeDetectorRef, ViewChild, TemplateRef, inject } from '@angular/core'
import {
  TypographyComponent,
  TypographyVariant,
} from '../typography/typography.component'
import { IconComponent } from '../icon/icon.component'
import { IconValuesType } from '../icon/icon.component.types'

@Component({
  selector: 'hyperkit-tab',
  standalone: true,
  imports: [CommonModule, TypographyComponent, IconComponent],
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent {
  cdr = inject(ChangeDetectorRef);

  private _variant: 'primary' | 'secondary' | 'tertiary' = 'primary'
  private _mode: 'underline' | 'text' = 'underline'
  private _selected = false

  @Input()
  set variant(value: 'primary' | 'secondary' | 'tertiary') {
    this._variant = value
    this.cdr.markForCheck()
  }

  get variant(): 'primary' | 'secondary' | 'tertiary' {
    return this._variant
  }

  @Input()
  set mode(value: 'underline' | 'text') {
    this._mode = value
    this.cdr.markForCheck()
  }

  get mode(): 'underline' | 'text' {
    return this._mode
  }

  @Input() icon: IconValuesType | null = null
  @Input() text = ''
  @Input() value = ''
  @Input() disabled = false
  @Input() count: number | null = null
  @Input() controlled = false

  @Output() tabClick = new EventEmitter<void>()

  @ViewChild('contentTemplate', { static: true })
  contentTemplate!: TemplateRef<any>

  @Input()
  set selected(value: boolean) {
    this._selected = value
    this.cdr.markForCheck()
  }

  get selected(): boolean {
    return this._selected
  }

  get typographyVariant(): TypographyVariant {
    switch (this.variant) {
      case 'primary':
        return 'h5'
      case 'secondary':
      case 'tertiary':
        return 'body'
      default:
        return 'body'
    }
  }

  onTabClick(): void {
    if (!this.disabled) {
      if (!this.controlled) {
        this.selected = true
      }
      this.tabClick.emit()
    }
  }

  deselect(): void {
    this.selected = false
    this.cdr.markForCheck()
  }
}
